import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import useCountdownTimer from '../../hooks/useCountdownTimer';
import { AuctionStatus } from '../../../constants/AuctionStatus';
import { BidStatusType } from '../../../constants/BidStatusType';
import { AuctionListTemplateContextType } from './AuctionListTemplate';

export const formatDate = (iso) => {
  if (!iso) return 'N/A';
  const m = moment(iso);
  return m.isValid() ? m.local().format('DD/MM/YY hh:mmA') : iso;
};

function AuctionCountdown({ item, context }) {
  const { publishSecondsLeft, status, endsOn, startsOn } = item || {};
  const organizationId = useSelector((state) => state.auth.get('organizationId'));

  const sellingFinishedStatuses = [
    AuctionStatus.SOLD,
    AuctionStatus.REJECTED,
    AuctionStatus.CANCELLED,
    AuctionStatus.ENDED,
    AuctionStatus.TO_ACCEPT,
  ];

  const buyingFinishedStatuses = [
    BidStatusType.WAITING,
    BidStatusType.TO_ACCEPT,
    BidStatusType.WON,
    BidStatusType.LOST,
    BidStatusType.REJECTED,
    BidStatusType.CANCELLED,
  ];

  const deriveBuyingStatus = () => {
    if (context !== AuctionListTemplateContextType.BUYING) return status;
    if (status !== AuctionStatus.SOLD) return status;
    const highest = Array.isArray(item?.bids) ? item.bids.find((b) => b?.isHighest) : null;
    if (highest && String(highest.bidderOrganizationId) === String(organizationId)) {
      return BidStatusType.WON;
    }
    return BidStatusType.LOST;
  };

  const displayStatus = deriveBuyingStatus();

  const finishedSet =
    context === AuctionListTemplateContextType.BUYING
      ? buyingFinishedStatuses
      : sellingFinishedStatuses;

  let valueToDisplay = useCountdownTimer(Math.max(publishSecondsLeft ?? 0, 0));
  let caption = 'Time left';

  if (finishedSet.includes(displayStatus)) {
    valueToDisplay = formatDate(endsOn);
    caption = 'Ended';
  } else if (context !== AuctionListTemplateContextType.BUYING) {
    if (status === AuctionStatus.DRAFT) {
      valueToDisplay = 'N/A';
    } else if (status === AuctionStatus.WAITING) {
      valueToDisplay = formatDate(startsOn);
      caption = 'STARTS ON';
    }
  }

  return (
    <>
      <span>{valueToDisplay}</span>
      <span>{caption}</span>
    </>
  );
}

export default AuctionCountdown;
